import React from 'react'
import PropTypes from 'prop-types';
import { Text, List, Flex } from '@leverege/ui-elements'
import { getAttributeCreators } from '@leverege/api-attributes';
import style from './style.css';
import ListModal from '../../views/ListModal';

export default class AddDialog extends React.Component {

  static propTypes = {
    onTypeSelected : PropTypes.func,
    path : PropTypes.string
  }

  constructor( props ) {
    super( props )

    this.state = {}
  }

  onItemSelected = ( { data } ) => {
    const { onClose, onTypeSelected } = this.props
    if ( onTypeSelected ) {
      onTypeSelected( data )
    }

    if ( onClose ) {
      onClose()
    }
  }

  render() {
    const { path, onHide, show = true } = this.props
    const flat = path.indexOf( '/' ) < 0
    const creators = getAttributeCreators();

    const units = []
    const other = []
    creators.forEach( ( c ) => {
      // TODO: hack
      // can't create parentRelationship attributes directly
      if ( ( c.typeName() === 'relationship' && !flat ) || c.typeName() === 'parentRelationship' ) {
        return
      }
      if ( c.isUnit ) {
        units.push( c )
      } else {
        other.push( c )
      }
    } )

    units.sort( ( a, b ) => { return a.name().localeCompare( b.name() ); } )
    other.sort( ( a, b ) => { return a.name().localeCompare( b.name() ); } )
    // creators = units.
    // creators.sort( function( a, b ) { return a.name().localeCompare( b.name() ); })

    const otypes = other.map( ( item, index ) => {
      return ( 
        <List.Item
          item={item}
          key={item.typeName()}>
          {item.name()}
        </List.Item>
      ) 
    } );
    const utypes = units.map( ( item, index ) => {
      return ( 
        <List.Item
          item={item}
          key={item.typeName()}>
          <Flex direction="row" justify="space-between" align-items="center">
            <span>{item.name()}</span>
            <span>{`${item.baseType()}`}</span>
          </Flex>
        </List.Item>
      ) 
    } );

    const mtypes = otypes.concat( [
      <div className={style.unitSep} key="sep">
        <span><strong>Units</strong></span> 
        {' '}
        <span>Example</span>
      </div>
    ], utypes )

    return (
      <ListModal
        title="Select Type"
        mtypes={mtypes}
        message={<Text>What kind of attribute is {path}?</Text>}
        onClose={onHide}
        show={show}
        onClick={this.onItemSelected} />
    )
  }
}

AddDialog.GROUP = 'group';
